import React from 'react';
import TripSelection from '../../../components/TripSelection';
import { useGetTripsQuery } from '../../../store/trips/tripsApi';
import { useGetCurrentUserQuery } from '../../../store/user/userApi';
import { ITrip } from '../../../interfaces/trips/ITrips';

const TripLogin = () => {
	const { data: userInfo } = useGetCurrentUserQuery();
	const { data: apiTrips, isLoading, error, refetch } = useGetTripsQuery(userInfo?.data?._id || '', {
		skip: !userInfo?.data?._id
	});


	// Transform API data to match Trip interface
	const transformTrips = (apiTrips: any[]): ITrip[] => {
		return apiTrips.map(trip => {
			return {
				id: trip._id,
				name: `Trip ${trip._id.slice(-6)}`, // Using last 6 chars of ID as trip name
				route: trip.journey,
				assignedCabins: trip.assignedCabins.map((cabin: {cabinId: string}) => cabin.cabinId),
				type: trip.isRoundTrip ? 'Round Trip' : 'One Way Trip', // Default type since API doesn't provide this
				duration: trip.duration,
				direction: trip.direction ,
				locations: trip.locations
			};
		});
	};

	const trips = apiTrips ? transformTrips(apiTrips) : [];

	const handleTripSelect = (tripId: string) => {
		// Handle trip selection logic here
		// For example: navigate to trip details, set selected trip in state, etc.
	};

	const handleRetry = () => {
		refetch();
	};

	if (isLoading) {
		return (
			<div className="min-h-screen bg-gray-50 flex items-center justify-center">
				<div className="text-center">
					<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
					<p className="text-gray-600">Loading trips...</p>
				</div>
			</div>
		);
	}

	if (error) {
		return (
			<div className="min-h-screen bg-gray-50 flex items-center justify-center">
				<div className="text-center">
					<div className="text-red-500 mb-4">
						<svg className="w-12 h-12 mx-auto" fill="currentColor" viewBox="0 0 20 20">
							<path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
						</svg>
					</div>
					<p className="text-gray-600 mb-4">Failed to load trips. Please try again.</p>
					<button 
						onClick={handleRetry}
						className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors"
					>
						Try Again
					</button>
				</div>
			</div>
		);
	}

	if (trips.length === 0) {
		return (
			<div className="min-h-screen bg-gray-50 flex items-center justify-center">
				<div className="text-center">
					<div className="text-gray-400 mb-4">
						<svg className="w-12 h-12 mx-auto" fill="currentColor" viewBox="0 0 20 20">
							<path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
						</svg>
					</div>
					<p className="text-gray-600">No trips found for this crew member.</p>
				</div>
			</div>
		);
	}

	return (
		<TripSelection 
			trips={trips} 
			onTripSelect={handleTripSelect} 
		/>
	);
};

export default TripLogin;